export default __webpack_public_path__ + "static/media/spotify.613a871c.png";